// extracted by mini-css-extract-plugin
export default {"main":"FormBtn_main__MS7Tu","btnActive":"FormBtn_btnActive__UgpUv","underText":"FormBtn_underText__n9kAG"};